export default __webpack_public_path__ + "static/media/AS-background.467f5750.svg";